<div class="ib-gift-card-info__container ib-gift-card-info__container--contribution">
    <div class="ib-gift-card">
        <figure class="ib-gift-card__logo">
            <img [src]="viewModel?.logo" [alt]="viewModel?.translates?.altLogo" />
        </figure>
        <figure class="ib-gift-card__figure">
            <img [src]="viewModel?.backGroundImage" [alt]="viewModel?.translates?.altFigure" />
        </figure>
        <figure class="ib-gift-card__icon"
                [ngClass]="viewModel?.iconClass">
            <img [src]="viewModel?.icon" [alt]="viewModel?.translates?.altTheme" />
        </figure>
        <div class="ib-gift-card__description">
            <span class="ib-gift-card__title">{{ viewModel?.translates?.title }}</span>
            <span
                [ngClass]="{
                    'ib-gift-card__price contributionLongPrice': isLongPrice,
                    'ib-gift-card__price': !isLongPrice
                }">
                    {{ form.get('giftCardAmount').value?.amount }} {{contributionService.contributionDataResponse.currency.symbol}}
            </span>
            <span class="ib-gift-card__txt">{{ viewModel?.translates?.expiration }} {{ expirationDate }}</span>
            <div id="contributionCodeContainer" class="ib-gift-card__contributionCodeContainer">
                <span class="ib-gift-card__txt">{{ viewModel?.translates?.code }} {{ code }}</span>
            </div>
        </div>
    </div>
</div>

